import { Routes } from '@angular/router';

//constants
import { ParamsConstants } from './shared/constants';

//guards
import { AppGuard } from './shared/guards/app.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/tools/initial',
    pathMatch: 'full',
  },
  {
    path: `tools/initial`,
    loadComponent: () => import('./welcome/welcome.component').then(m => m.WelcomeComponent),
  },
  {
    path: `tools/initial/:${ParamsConstants.UUID}`,
    loadComponent: () => import('./welcome/welcome.component').then(m => m.WelcomeComponent),
  },
  {
    path: `scan-client/:${ParamsConstants.UUID}/:${ParamsConstants.TYPE}`,
    loadComponent: () => import('./scan-client/scan-client.component').then(m => m.ScanClientComponent),
    canActivate: [AppGuard],
  },
  {
    path: `:${ParamsConstants.UUID}/B2B`,
    loadChildren: () => import('./B2B/B2B.routes').then(m => m.B2BRoutes),
    //canActivate: [AppGuard],
  },
  {
    path: `:${ParamsConstants.UUID}/B2C`,
    loadChildren: () => import('./B2C/B2C.routes').then(m => m.B2CRoutes),
    //canActivate: [AppGuard],
  },
  {
    path: '**',
    loadComponent: () => import('./no-page/no-page.component').then(m => m.NoPageComponent),
  }
];
